import { render, staticRenderFns } from "./infoCategoria.vue?vue&type=template&id=57978182&scoped=true"
import script from "./infoCategoria.vue?vue&type=script&lang=js"
export * from "./infoCategoria.vue?vue&type=script&lang=js"
import style0 from "./infoCategoria.vue?vue&type=style&index=0&id=57978182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57978182",
  null
  
)

export default component.exports